import {baseResponseGraphqlField} from "../../../store/base.graphql";
import {gql} from "apollo-angular";

const citizenServiceFewFields = `
  id
  serviceUniqueId
  serviceName
  serviceDescription
`;

export const CITIZEN_GET_SEARCHED_SERVICES = gql`
  query CitizenGetSearchedServices($searchKey: String) {
    citizenGetSearchedServices(searchKey: $searchKey) {
      ${baseResponseGraphqlField}
      data {
        id
        serviceUniqueId
        serviceName
      }
    }
  }
`


export const UPDATE_SEARCHED_SERVICE = gql`
  mutation CitizenUpdateSearchedServiceMutation($serviceUniqueId: String) {
    citizenUpdateSearchedServiceMutation(serviceUniqueId: $serviceUniqueId) {
      ${baseResponseGraphqlField}
    }
  }
`


export const CITIZEN_GET_MOST_SEARCHED_SERVICES = gql`
  query CitizenGetMostSearchedServices {
    citizenGetMostSearchedServices {
      ${baseResponseGraphqlField}
      data {
        ${citizenServiceFewFields}
      }
    }
  }
`


export const CITIZEN_GET_PROVIDERS_SUMMARIES = gql`
  query CitizenGetProvidersSummaries {
    citizenGetProvidersSummaries {
      ${baseResponseGraphqlField}
      data {
        provider {
          id
          institutionUniqueId
          institutionName
          institutionShortform
          institutionPhysicalAddress
          institutionEmail
          institutionPostcode
          institutionWebsite
          institutionPhones
          institutionMapUrl
          institutionLogo
        }
        serviceCounts
      }
    }
  }
`


export const CITIZEN_GET_MOST_POPULAR_SERVICES = gql`
  query CitizenGetMostPopularServices {
    citizenGetMostPopularServices {
      ${baseResponseGraphqlField}
      data {
        ${citizenServiceFewFields}
        serviceProvider {
            institutionName
        }
      }
    }
  }
`

export const GET_LANDING_STATS = gql`
  query GetLandingStats {
    getLandingStats {
      response {
        id
        status
        code
        message
      }
      data {
        totalServices
        totalCitizens
        totalCitizenFeedbacks
        totalInstitutions
        totalIntegratedServices
        totalAutomatedServices
        totalPerGroupOfService {
          group
          total
        }
      }
    }
  }`
